import { CIDocument } from "../clearance-item/clearance-item.model";

export class IProject {

    id: string;
    name: string;
    keyCode: string;
    uniqueId: string;
    releaseDate: string;
    startDate: string;
    wprBillingCode: string;
    wrapDate: string;
    comments: string;
    defaultProductionOffice: string;
    department: string;
    productionOffices: IPRoductionOffice[];
    defaultProductionContact: string;
    productionContacts: IProductionContact[];
    defaultProjectContact: string;
    projectContacts: IProjectContact[];
    documents: CIDocument[];
    constructor(){
    }
}


export class IPRoductionOffice{
    id: string;
    entity: string;
    address: string;
    phoneNumber: string;
}

export class IProductionContact{
    id: string;
    name: string;
    title: string;
    phoneNumber: string;
    phoneNumber2: string;
    phoneNumber3: string;        
    email: string;
}

export class IProjectContact{
    id: string;
    name: string;
    title: string;
    email:string;
    phoneNumber: string;
    emailNotification: boolean;
    emailNotificationDiv: string;
    selected:boolean;
}

export class IHelpDocsReference{
    id: string;
    name: string;
    path:string;
    isDefault: boolean;
    toolTipDelay: number;
    toolTipDelayM: number;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/project/project.model.ts